import { environment } from 'src/environments/environment';

//Constant Used In Route-navigate.
export const RoutesAll = {
    //Constant Used In Authenication ,forgotcomponent,LoginComponent.
    "authLogin": 'lender/authentication/login',
    "authAddCustomer": 'lender/authentication/addcustomer',
    //"authAddOrder": 'lender/authentication/order',
    "home": 'home',
    "lender": 'lender',
    "establishment": 'establishment',
    "getconsent": 'getconsent',
    "place-order-borrower": 'place-order-borrower',
    "userInfo": 'corpository/user',
    //checkCredentials IN Authentication.service
    "login": 'lender/authentication/login',
    "orderDetail":'orderDetail',
    //Constant used In buyDocument.
    "authenication": 'lender/authentication/login',
    "accessDenied":'accessDenied',
    "get_borrower_details": window.location.origin + environment.getBorrowerDetailsURL
};

export const lender = {
    //Constant Used In Authenication ,forgotcomponent,LoginComponent.
    "authLogin": 'lender/authentication/login',
    "authAddCustomer": 'lender/authentication/addcustomer',
    "authAddOrder": 'lender/authentication/order',
    //"home": 'home',
    "lender": 'lender',
    "userInfo": 'corpository/user',
    //checkCredentials IN Authentication.service
    "login": 'lender/authentication/login',

    //Constant used In buyDocument.
    "authenication": 'lender/authentication/login',
};

//Constant Used In Request URL.
export const RequestURL = {
    "placeOrder": "/placeOrder",
    "sendOTP": "/getotp",
    "verifyOTP": "/getsession",
    "gstinList": "/gstin-list",
    // "currency":"/gstin/rest/customer/getMaster/CURRENCY",
    //  "report_type":"/gstin/rest/customer/getMaster/REPORT",
    //  "extraction_method":"/gstin/rest/customer/getMaster/EXTRACTION",
    "currency": "/gstmaster/CURRENCY",
    "report_type": "/gstmaster/REPORT",
    "extraction_method": "/gstmaster/EXTRACTION",
    // "allOrder": "http://64.225.116.40:8080/corpository/v1/allOrder",
    "place_order": "/newOrder",
    "gstin_list": "/establishmentPage",
    "entity_list": "/allOrder",
    "placeGSTOrder":"/createDigitalPdfOrder",
    "checkPanValid":"/isPanValid",
    "add_mail": "/addemail",
    "delete_mail": "/deleteemail",
    "send_link": "/sendconsentlink",
    "get_borrower_details": "/getborrowerdetails?gstin_id=",
    "generate_otp": "https://test-analyze2-api.corpository.com/entergstusername",
    "downloadDoc": "/download-bi-report",
    "resendOTP": "/resendOtp",
    "taxPayer": "/",
    "generate_otp_consent_link": "/entergstusername",
    "resend_otp_consent_link": "/regenerateotp",
    "submit_otp_consent_link": "/submitotp",
    "capture_consent_approval": "/consentcapture",
    "downloadReport": "/downloadreport",
    "generate_captcha_consent_link": "/generateCaptcha",
    "submit_login_consent_link": "/submitLogin",
    "generate_captcha_workorder":"/generateCaptchaWorkorder",
	"get_entity_deatil_page_detail":"/getDigitalPdfFileStatus",
	"download_error_file":"/getDigitalPdfErrorFileDownload",
	"download_excel_file":"/getExcelReport",
	"merge_report":"/mergeExcelReport",
	"get_error_file_list":"/getErrorFiles",
    "downloadExcelNew":"/downloadReportNew",
    "fetchUserPreferances":"/fetchUserPreferances",
    "fetchSystemPreferance":"/fetchSystemPreferances",
    "fetchBorrowerPreferance":"/fetchBorrowerPreferences",
    "fetchOrderDueDate":"/fetchOrderDueDate",
    "updateUserPreferances":"/updateUserPreferances",
    "fetchStatus":"/getStatus",
    "fetchStatusForGst":"/getStatusForGst",
    "fetchStatusForGenerateOtp":"/getStatusForOrders",
    "fetchDisclaimerProperty":"/fetchDisclaimerProperty"
};

// Common Constant Used Throughout Web App.
export const commonConstants = {
    "companyName": "company_name",
    "userId": "user_id",
    "life": "6000",
    "companyId": 'company_id',
    "apiToken": "api_auth_token",
    "notificationCount": "unread_notification_count",
    "cartCount": "my_cart_count",
    "saveForLaterCount": "saved_for_later_count",
    "authenticationError": "Please Login In Corpository",
    "firstName": 'first_name',
    "purchaseStatus": "purchaseStatus",
    "dbCompany": "dbCompany",
    "userSettings": "user_settings",
    "viewConfig": "viewConfig",
    "isCorporateUser": "isCorporateUser",
    "processedViewIndex": "processedViewIndex",
    "lastBoughtCompany": "lastBoughtCompany",
    "lastBoughtOrder": "lastBoughtOrder",
    "lastBoughtOrderProcessed": "lastBoughtOrderProcessed",
    "sectionData": "sectionData",
    "referenceNo": "term_reference_no",
    "version": "verison",
    "termConditionLink": "terms_condition_link",
	"fileTypePdf" : "application/pdf",
	"fileTypeZip" : "application/zip"
};

export const Cookies = {
    "userEmailAddress": "user_email_address",
    "userId": "user_id",
    "apiToken": "api_auth_token",
    "gstEmailAddress": "gst_email_address",
    "gstusername": "gst_user_name",
    "gstin": "gstin",
    "userName": "user_name",
    "corporateName": "corporate_name",
    "displayName": "display_name",
    "corporateId": "corporate_id",
    "fromDate": "from_date",
    "toDate": "to_date",
    "requestId": "request_id",
    "jobMasterId": "jobMasterId",
    "entity_name": "entity_name",
    "pan": "cin",
    "lenderEmail": "lender_email"
};


// Constant Used In all Message.
export const StaticMessage = {
    "failureError": "Something went wrong. Please contact support at support@corpository.com",
};

export const limitConstant = {

    "limitOfEmailCount" : 5,
    "intervalForEntityDetailPage" : 5,
    "intervalForEstablishment": 5
}

